import React from 'react';
import Header from '../../components/Header';
import IconFeatureFlags from '../../components/icons/IconFeatureFlags';

interface Props {
    subtitle?: string;
}

export function GatedContentHeader({ subtitle = 'Restrict access to your subscriber-only content' }: Props) {
    return (
        <Header>
            <IconFeatureFlags className="inline w-6 mr-3" /> Gated Content
            <span className="text-lg font-light ml-2">{subtitle}</span>
        </Header>
    );
}
